export default "__VITE_ASSET__9lTzMeoN__"